import gql from 'graphql-tag';
import { INTERACTION, LAYER_IDS, PANEL, MAP_TOOL, NOTE_TOOLS } from '@tmapy/config';
import { batch } from '@tmapy/redux';
import { GeoJSONToEWKT, EWKTToGeoJSONObject, actionSetLayerFeatures, actionDeleteFeatures, actionSetInteraction, actionMergeLayers, } from '@tmapy/mapcore';
import { actionUpdateHashParams } from '@tmapy/router';
import { QUERY_STATE } from '@tmapy/utils';
import { actionSetMapTool, actionSetPanel } from '@tmapy/ui-manager';
import { NOTES_SAVE_START, NOTES_SAVE_SUCCESS, NOTES_SAVE_FAILURE, NOTES_SET_STATE, NOTE_HASH_PARAM_NAME, ACTION_INTERACTION_MODIFY, } from './constants';
const saveNoteMutation = gql `
  mutation saveNoteMutation($note: createNoteInput!) {
    createNote(input: $note) {
      note {
        _id
        id
      }
    }
  }
`;
const actionSaveNotesStart = () => ({
    type: NOTES_SAVE_START,
});
const actionSaveNotesSuccess = () => ({
    type: NOTES_SAVE_SUCCESS,
});
const actionSaveNotesFailure = () => ({
    type: NOTES_SAVE_FAILURE,
});
export const actionActivateNotes = () => (dispatch, getState) => {
    const state = getState();
    if (state.uiManager.visiblePanel !== PANEL.NOTES) {
        dispatch(actionSetMapTool(MAP_TOOL.NOTE_SELECT));
        dispatch(actionSetInteraction(ACTION_INTERACTION_MODIFY));
        dispatch(actionSetPanel(PANEL.NOTES));
    }
};
export const actionDeactivateNotes = () => (dispatch, getState) => {
    const state = getState();
    const activeMapTool = state.uiManager.activeMapTool;
    if (NOTE_TOOLS.includes(activeMapTool)) {
        dispatch(actionSetMapTool(MAP_TOOL.NONE));
        dispatch(actionSetInteraction({ type: INTERACTION.NONE }));
        dispatch(actionMergeLayers({
            fromLayerId: LAYER_IDS.NOTES_MODIFY,
            toLayerId: LAYER_IDS.NOTES,
        }));
    }
    dispatch(actionSetPanel(PANEL.NONE));
};
export const actionSetNotesState = (payload) => ({
    type: NOTES_SET_STATE,
    payload,
});
export const actionSaveNotes = (client, note) => async (dispatch, getState) => {
    dispatch(actionSaveNotesStart());
    const state = getState();
    const mapProjection = state.mapCore.view.projection;
    const variables = {
        note: {
            ...note,
            features: note.features.map((feature) => {
                const properties = feature.properties ?? {};
                return {
                    geom: GeoJSONToEWKT(feature, mapProjection, 'EPSG:4326'),
                    text: properties.label ?? '',
                    // note: String
                    // text: String!
                    // lineWidth: Int
                    // hasStartArrow: Boolean
                    // hasEndArrow: Boolean
                    // color: String
                    // textSize: Int
                    // fillOpacity: Float
                    // measurement: Boolean
                    // geom: EWKT!
                    // clientMutationId: String
                };
            }),
        },
    };
    try {
        const result = await client.mutate({
            mutation: saveNoteMutation,
            variables,
        });
        const noteId = result.data.createNote.note._id;
        dispatch(actionSetNotesState({ currentNoteId: noteId }));
        dispatch(actionUpdateHashParams({
            [NOTE_HASH_PARAM_NAME]: noteId,
        }));
        await client.reFetchObservableQueries();
        dispatch(actionSaveNotesSuccess());
    }
    catch (err) {
        dispatch(actionSaveNotesFailure());
    }
};
const NOTE_ID_PREFIX = '/api/map-notes/notes/';
const loadNote = gql `
  query loadNote($id: ID!) {
    note(id: $id) {
      id
      _id
      agendaName
      routeId
      url
      createdAt
      updatedAt
      features {
        edges {
          node {
            id
            _id
            text
            lineWidth
            hasStartArrow
            hasEndArrow
            color
            textSize
            fillOpacity
            measurement
            geom
          }
        }
      }
    }
  }
`;
export const actionLoadNote = (client, _id) => async (dispatch, getState) => {
    const state = getState();
    if (state.notes.currentNoteId === _id) {
        return;
    }
    const mapProjection = state.mapCore.view.projection;
    const result = await client.query({
        query: loadNote,
        variables: {
            id: `${NOTE_ID_PREFIX}${_id}`,
        },
    });
    const noteFeatures = result.data.note.features.edges.map(({ node }) => {
        const geoJsonFeature = EWKTToGeoJSONObject(node.geom, mapProjection);
        geoJsonFeature.id = node._id;
        geoJsonFeature.properties = {
            label: node.text,
            id: node._id,
        };
        return geoJsonFeature;
    });
    dispatch(actionSetLayerFeatures(LAYER_IDS.NOTES, noteFeatures));
    dispatch(actionSetNotesState({
        currentNoteId: result.data.note._id,
    }));
};
export const actionNoteDeleteAll = (hashParams) => (dispatch) => {
    batch('actionNoteDeleteAll', () => {
        dispatch(actionUpdateHashParams(hashParams));
        dispatch(actionSetNotesState({ currentNoteId: null, saveQueryState: QUERY_STATE.EMPTY }));
        dispatch(actionSetLayerFeatures(LAYER_IDS.NOTES, []));
        dispatch(actionSetLayerFeatures(LAYER_IDS.NOTES_MODIFY, []));
    });
};
export const actionNoteDelete = (selectedFeatureIds) => (dispatch) => {
    batch('actionNoteDelete', () => {
        dispatch(actionDeleteFeatures(LAYER_IDS.NOTES, selectedFeatureIds));
        dispatch(actionSetLayerFeatures(LAYER_IDS.NOTES_MODIFY, []));
        dispatch(actionSetNotesState({ saveQueryState: QUERY_STATE.EMPTY, isChanged: true }));
    });
};
//# sourceMappingURL=actions.js.map